import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography } from '@mui/material';
import { useContext } from 'react';
import { Z3KSettingsEditor, Z3KSettingsState } from 'z3k-settings/provider/types';
import { BoilerAdapter } from 'z3k-config';
import { findAndChangeLinks } from 'z3k-parser/lib';
import { Replay } from '@mui/icons-material';
import { HelpIcon } from 'shared/components/fields/help-icon';
import { useConfirmDialog } from 'shared/hooks/ui';
export function RefreshBoilerAdaptersBtn() {
    const { config } = useContext(Z3KSettingsEditor);
    const { z3k_state } = useContext(Z3KSettingsState);
    const onButtonClick = () => {
        const slot1_connection = [];
        const slot1_no_connection = [];
        const slot2_connection = [];
        const slot2_no_connection = [];
        BoilerAdapter.get.all(config).forEach((item) => {
            const no_adapter_connection = !!z3k_state?.[item.id]?.status?.no_adapter_connection;
            if (item.slot === 1 && !no_adapter_connection) {
                slot1_connection.push(item);
                return;
            }
            if (item.slot === 1 && no_adapter_connection) {
                slot1_no_connection.push(item);
                return;
            }
            if (item.slot === 2 && !no_adapter_connection) {
                slot2_connection.push(item);
                return;
            }
            if (item.slot == 2 && no_adapter_connection) {
                slot2_no_connection.push(item);
                return;
            }
        });
        let new_config = config;
        if (slot1_no_connection.length > 0 && slot1_connection.length === 1) {
            slot1_no_connection.forEach((item) => {
                new_config = findAndChangeLinks(new_config, item.id, slot1_connection[0].id);
            });
        }
        if (slot2_no_connection.length > 0 && slot2_connection.length === 1) {
            slot2_no_connection.forEach((item) => {
                new_config = findAndChangeLinks(new_config, item.id, slot2_connection[0].id);
            });
        }
    };
    const [ConfirmDialog, openConfirmDialog] = useConfirmDialog();
    return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "contained", onClick: openConfirmDialog, fullWidth: true, color: "neutral_light", startIcon: _jsx(Replay, {}), children: "\u0421\u0431\u0440\u043E\u0441 \u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u043F\u0438\u0441\u043A\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044B\u0445 \u0430\u0446\u0448" }), _jsx(HelpIcon, { help_id: "refresh_boiler_adapters_btn" }), _jsx(ConfirmDialog, { onConfirm: onButtonClick, content: _jsx(Box, { children: _jsx(Typography, { children: "\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044B\u0435 \u0410\u0426\u0428 ?" }) }) })] }));
}
